module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAXCAYAAADQpsWBAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADqSURBVHgB3dI/DoIwFAbw11dK/LPoCcTJa3gFF1fxBOoJ1JPoRtz0BOoJdGPVE0BijCQKtZCgQNqCq99Cafn4EfIAJPFcx7q7mwUogrJNk7I5QTLxTqtWpVKsEB7ZYtkya41ppVKspGuVhgoljVRDlaLTUKMoNdQpKg0zSh/UyWlJqWYYI3GxNKWchrHCI25DeT4aVlGKmhG++JUAXya7lHYkf/AsvmSX3jBmWiR7enOdPkW6z70dYF3vDcfZPenAluXvS4RS/+fSk7FL8YEwCo/aUrs78IFHsy9NDs0g2EKVcDEqDzGTqvM3XBBbLDps0yMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gamecompetition/up.png
// module id = 5sz5
// module chunks = 0